<template>
  <audio controls>
    <source :src="audio" type="audio/mpeg">
    Your browser does not support the audio tag.
  </audio>
</template>

<script>
export default {
  name: "Audio",
  props: {
    audio: {
      default: ''
    },
  }
}
</script>

<style scoped>

</style>